const WORDS = [
  "Chicken Biryani",
  "Goat Nihari",
  "Chicken Karahi",
  "Goat Korma",
  "Zarda",
  "Daal Makni",
  "Beef Biryani",
  "Lahori Channay",
];

export const Marquee = () => (
  <div
    data-testid="marquee"
    className="relative overflow-hidden border-y border-nosh-gold/40 bg-nosh-green py-6 text-nosh-cream"
  >
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {WORDS.map((w, i) => (
            <span key={`${dup}-${i}`} className="flex items-center">
              <span className="px-8 font-display text-2xl font-medium italic text-nosh-cream md:text-3xl">{w}</span>
              <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-nosh-gold" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
